import { Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import { injectIntl } from "react-intl";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import imageCompression from "browser-image-compression";

import {
  catchUIError,
  uploadPostWeight,
  uploadPreWeight,
} from "../../_redux/pets";
import jsonHelper from "../../../../../_artifact/helpers/jsonHelper";
import { translate } from "../../../../../_artifact/i18n";
import ErrorMessage from "../../../../../_artifact/components/forms/ErrorMessage";
import Modal from "../../../../../_artifact/components/Modal";
import config from "../../../../config";
import { trackingLog } from "../../../Tracking/_redux/tracking";

import { fetchPreviousTestDetails } from "../../../Testing/_redux/previousTests";
import { format } from "date-fns";
import RedirectModel from "../../../../../_artifact/components/RedirectModel";

const initialValues = {
  product_post_wt: "",
  product_post_img: "",
  product_bowl_wt: "",
};

function PostWeight({ intl, history }) {
  const { state, panelist_details } = useSelector(
    (state) => ({
      state,
      panelist_details: state.pets.entities.panelist_details, // Access panelist_details here
    }),
    shallowEqual
  );
  const [imageURL, setImageURL] = useState("");
  const { testDetails } = state.previousTests;
  const [fileName, setFileName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const imgRef = useRef(null);
  let count = useRef(0);
  const selectedTest = useRef({});
  const [panelistCountry, setPanelistCountry] = useState(null); // State to store the country
  const [fieldValue, setFieldValue] = useState(null);
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    product_post_img: Yup.mixed()
      .required(translate("APP.VALIDATION.REQUIRED_FIELD", intl))
      .test(
        "fileFormat",
        translate("APP.VALIDATION.UNSUPPORTED_FILE_TYPE", intl),
        (value) => value && value.type.includes("image")
      ),
    product_post_wt: Yup.number()
      .typeError(translate("APP.VALIDATION.INVALID_VALUE", intl))
      .min(0, translate("APP.VALIDATION.INVALID_VALUE", intl))
      .required(translate("APP.VALIDATION.REQUIRED_FIELD", intl)),
    // product_bowl_wt: Yup.number()
    //   .transform((value, originalValue) =>
    //     String(originalValue).trim() === "" ? 0 : value
    //   )
    //   .when([], {
    //     is: () => panelistCountry?.toLowerCase() === "usa", // Use panelistCountry here
    //     then: (schema) =>
    //       schema
    //         .required(translate("APP.VALIDATION.REQUIRED_FIELD", intl))
    //         .min(1, translate("APP.VALIDATION.INVALID_VALUE", intl)),
    //     otherwise: (schema) => schema.notRequired(),
    //   }),
  });

  const { trackingPayload } = useSelector(
    (state) => state.tracking,
    shallowEqual
  );
  useEffect(() => {
    const jsonString = localStorage.getItem("selectedTest");
    const myObject = JSON.parse(jsonString);
    localStorage.setItem("postWeightStartTime", new Date().toISOString());
    localStorage.setItem("preWeight", myObject?.product_pre_wt);
    selectedTest.current = myObject;
    if (!myObject?.test_schedule_id) {
      history.replace("/testing/codes");
    } else {
      dispatch(
        fetchPreviousTestDetails({
          panelist_id: myObject?.panelist_id,
          test_schedule_id: myObject?.test_schedule_id,
          product_id: myObject?.product_id,
          country: panelist_details.country,
        })
      );
    }
    // Set the panelistCountry state from Redux
    if (panelist_details?.country) {
      setPanelistCountry(panelist_details.country);
    }
    if (testDetails?.product_bowl_wt) {
      setFieldValue("product_bowl_wt", testDetails.product_bowl_wt);
    }
    return () => {
      if (imgRef.current) URL.revokeObjectURL(imgRef.current);
    };
  }, [panelist_details, dispatch]); // Add panelist_details and dispatch to dependency array

  const handleSubmit = (values) => {
    var preWeight = localStorage.getItem("preWeight");
    const final_weight =
      +values.product_post_wt - +testDetails?.product_bowl_wt;

    if (+values.product_post_wt - +testDetails?.product_bowl_wt > +preWeight) {
      setIsOpen(true);
      return;
    }

    values.product_post_wt = final_weight;
    //values.product_post_wt = values.product_post_wt;
    values.test_schedule_id = selectedTest.current.test_schedule_id;
    values.panelist_id = selectedTest.current.panelist_id;
    values.product_id = selectedTest.current.product_id;
    values.country = panelist_details.country;

    imgRef.current = imageURL;

    const base64Image = testDetails?.product_pre_img;

    // Strip the base64 prefix
    const base64 = base64Image.split(",")[1];

    // Convert base64 to binary
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Create a Blob (image/jpeg)
    const imageBlob = new Blob([bytes], { type: "image/jpeg" });

    const payload = { ...values };

    payload.product_pre_wt = testDetails?.product_pre_wt;
    payload.product_pre_img = imageBlob;
    //payload.test_schedule_id = selectedTest.current.test_schedule_id;
    payload.language = localStorage.getItem("language");
    payload.species = selectedTest.current.species;
    payload.product_bowl_wt = testDetails?.product_bowl_wt;
    //payload.panelist_id = selectedTest.current.panelist_id;
    //payload.product_id = selectedTest.current.product_id;

    count.current = count.current + 1;
    const api = () => {
      dispatch(uploadPostWeight(jsonHelper.jsonToForm(values)))
        .then(() => {
          dispatch(uploadPreWeight(jsonHelper.jsonToForm(payload))).then(
            () => {}
          );
          toast.success(
            translate("TESTING.TOAST.WEIGHT_LEFTOVER_SUCCESS", intl)
          );
          dispatch(
            trackingLog({
              ...trackingPayload,
              final_weight: final_weight,
              //final_weight: values.product_post_wt,
              end_image_url: imageURL,
            })
          );
          history.replace("/testing/finish");
        })
        .catch((error) => {
          dispatch(
            trackingLog({
              ...trackingPayload,
              api_log:
                error["stack"] +
                " | PostWeight " +
                format(new Date(), "yyyy-MM-dd HH:mm:ss") +
                " |" +
                error.message,
              final_weight: final_weight,
              //final_weight: values.product_post_wt,
              end_image_url: imageURL,
            })
          );

          if (count.current >= 2) {
            setOpen(true);
            alert("Please take the screenshots of this." + error);
          }
          error.clientMessage = translate(
            "TESTING.TOAST.WEIGHT_LEFTOVER_FAILED",
            intl
          );
          dispatch(catchUIError(error));
        });
    };
    api();
  };

  const handleCapture = async (e, setFieldValue) => {
    if (e.target.files.length === 0) {
      setFieldValue("product_post_img", "");
      if (imageURL) URL.revokeObjectURL(imageURL);
      setImageURL("");
      return;
    }

    const file = e.target.files[0];

    const options = {
      maxSizeMB: config.file.maxSizeMB,
      maxWidthOrHeight: config.file.maxWidthOrHeight,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);

      setFieldValue("product_post_img", compressedFile);
      if (imageURL) URL.revokeObjectURL(imageURL);
      setImageURL(URL.createObjectURL(compressedFile));
      setFileName(compressedFile.name);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="inner-page">
      <Modal
        isOpen={isOpen}
        action={translate("TESTING.BUTTON.ENTER_AGAIN", intl)}
        title={translate("TESTING.GENERAL.LEFTOVER_GREATER_THAN_OFFERED", intl)}
        icon="icon-circle-exclamation text-danger font-200"
        onClose={() => setIsOpen(false)}
      />

      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ setFieldValue, handleSubmit, errors, touched }) => (
          <div className="test-box">
            <div className="form-group inline-label enter-weight">
              {panelist_details.country?.toLowerCase() === "usa" && (
                <div className="form-group inline-label enter-weight">
                  <label>
                    {translate("TESTING.GENERAL.WEIGTH_BOWL", intl)}
                  </label>
                  <div className="input-error-field-wrapper">
                    <input
                      //name="product_bowl_wt"
                      type="number"
                      //onWheel={(e) => e.currentTarget.blur()}
                      className="form-control"
                      placeholder="gms"
                      value={testDetails?.product_bowl_wt ?? ""}
                      disabled
                      // onChange={(e) =>
                      //   setFieldValue("product_bowl_wt", e.target.value)
                      // }
                    />
                    <ErrorMessage
                      error={errors.product_bowl_wt}
                      visible={touched.product_bowl_wt}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="form-group  enter-weight">
              {panelist_details.country?.toLowerCase() === "usa" && (
                <label>
                  {translate("TESTING.GENERAL.TARE_SCALE", intl)}
                  {translate("TESTING.GENERAL.TARE", intl)}
                </label>
              )}
            </div>

            <div className="form-group inline-label enter-weight">
              <label>
                {translate(
                  "TESTING.GENERAL.ENTER_THE_WEIGTH_FOOD_LEFTOVER",
                  intl
                )}
              </label>
              <div className="input-error-field-wrapper">
                <input
                  name="product_post_wt"
                  type="number"
                  onWheel={(e) => {
                    e.currentTarget.blur();
                  }}
                  className="form-control"
                  placeholder="gms"
                  onChange={(e) =>
                    setFieldValue("product_post_wt", e.target.value)
                  }
                />
                <ErrorMessage
                  error={errors.product_post_wt}
                  visible={touched.product_post_wt}
                />
              </div>
            </div>
            <h3 className="test-box-title desktop-only">
              <i className="icon-capture"></i>{" "}
              {translate("TESTING.GENERAL.CAPTURE_WEIGHT_LEFTOVER", intl)}
            </h3>
            <div className="capture-wrap">
              {imageURL && (
                <div className="caputred-image-wrap">
                  <div className="caputred-image">
                    <img src={imageURL} alt="" />
                  </div>
                  <div className="caputred-image-info">
                    <span className="file-name">{fileName}</span>
                    <span className="reupload">
                      {translate("TESTING.GENERAL.RE_UPLOAD", intl)}
                      <i className="icon-reload"></i>
                      <input
                        name="product_pre_img"
                        type="file"
                        capture="environment"
                        accept="image/*"
                        onChange={(e) => handleCapture(e, setFieldValue)}
                      />
                    </span>
                  </div>
                </div>
              )}
              {!imageURL && (
                <div className="capture-inner">
                  <div className="c-left">
                    <h3 className="test-box-title mobile-only">
                      <i className="icon-capture"></i>{" "}
                      {translate("TESTING.GENERAL.CAPTURE_WEIGHT", intl)}
                    </h3>
                    <div className="upload text-center desktop-only">
                      <img src="/assets/images/upload.svg" alt="" />
                      <p>
                        {translate("TESTING.GENERAL.DRAN_AND_DROP", intl)}{" "}
                        <br />
                        {translate("APP.GENERAL.OR", intl)}
                      </p>
                      <button className="btn btn-outline-primary btn-h-40 use-camera">
                        {translate("TESTING.GENERAL.BROWSE", intl)}
                        <input
                          name="product_post_img"
                          type="file"
                          capture="environment"
                          accept="image/*"
                          onChange={(e) => handleCapture(e, setFieldValue)}
                        />
                      </button>
                    </div>
                  </div>
                  <div className="c-right">
                    <p>
                      {translate("TESTING.GENERAL.CLICK_PICTURE", intl)}{" "}
                      <strong>
                        {translate("TESTING.GENERAL.LEFTOVER_FOOD", intl)}
                      </strong>{" "}
                      {translate("TESTING.GENERAL.TO_THE_PET", intl)}
                    </p>
                    <div className="c-instruction">
                      <p>
                        {translate("TESTING.GENERAL.PICTURE_SHOULD_SHOW", intl)}{" "}
                        <br />
                        &nbsp; 1.{" "}
                        <strong>
                          {translate("TESTING.GENERAL.FOOD", intl)}
                        </strong>{" "}
                        {translate("TESTING.GENERAL.IN_THE_BOWL", intl)}
                        <br />
                        &nbsp; 2.{" "}
                        <strong>
                          {translate("TESTING.GENERAL.BOWL", intl)}
                        </strong>{" "}
                        {translate(
                          "TESTING.GENERAL.SHOULD_BE_ON_THE_SCALE",
                          intl
                        )}
                        <br />
                        &nbsp; 3.{" "}
                        <strong>
                          {translate("TESTING.GENERAL.WEIGHT", intl)}
                        </strong>{" "}
                        {translate(
                          "TESTING.GENERAL.CLEARLY_INDICATED_ON_THE_SCALE",
                          intl
                        )}
                      </p>
                    </div>
                    <button className="btn btn-outline-primary btn-h-40 btn-block use-camera mobile-only">
                      {translate("TESTING.GENERAL.USE_CAMERA", intl)}
                      <input
                        name="product_post_img"
                        type="file"
                        capture="environment"
                        accept="image/*"
                        onChange={(e) => handleCapture(e, setFieldValue)}
                      />
                    </button>
                  </div>
                </div>
              )}
              <ErrorMessage
                error={errors.product_post_img}
                visible={touched.product_post_img}
              />
            </div>
            <div className="text-center action-btn">
              <button
                type="submit"
                className="btn btn-primary btn-block"
                onClick={handleSubmit}
              >
                {translate("TESTING.BUTTON.NEXT", intl)}
              </button>
            </div>
          </div>
        )}
      </Formik>
      <RedirectModel history={history} isOpen={open} />
    </div>
  );
}

export default injectIntl(PostWeight);
